import {
  createPlayerManagerStore,
  type ExtraStateCreator,
} from '@tunein/web-player-manager/vanilla';

export interface PlayerState {
  popout: {
    showButton?: boolean;
    isDialogOpen?: boolean;
    externalUrl?: string;
  };
  showVolumeBar: boolean;
}

export interface PlayerActions {
  setPopoutState: (popoutState: PlayerState['popout']) => void;
  setShowVolumeBar: (showVolumeBar: boolean) => void;
}

export type PlayerStore = PlayerState & PlayerActions;
export type InitialPlayerState = Partial<PlayerState>;

const defaultState: PlayerState = {
  popout: {
    showButton: false,
    isDialogOpen: false,
    externalUrl: '',
  },
  showVolumeBar: false,
};

/**
 * The fields serialized into the page. Player-manager state always starts from its defaults in the
 * browser, so only this app's own fields are sent.
 */
export const playerStateKeys = Object.keys(defaultState) as (keyof PlayerState)[];

export function createPlayerStore(initialState: InitialPlayerState = {}) {
  const extraStateCreator: ExtraStateCreator<PlayerStore> = (set) => ({
    ...defaultState,
    ...initialState,

    setPopoutState: (popout: PlayerState['popout']) =>
      set((prevState) => ({ popout: { ...prevState.popout, ...popout } })),
    setShowVolumeBar: (showVolumeBar: boolean) => set({ showVolumeBar }),
  });

  return createPlayerManagerStore<PlayerStore>(extraStateCreator);
}
